export default __webpack_public_path__ + "4093f83933f05efb2da4fa4df295ff09.svg";